import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonitorTaskService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  refreshProducts = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  getListTasksByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/ListTasksByAdmin`, { params });
  }

  createTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/MonitorTask/CreateTask`, data);
  }

  removeTask(id: number) {
    return this.http.delete(`${environment.apiUrl}/MonitorTask/RemoveTask?id=${id}`);
  }

  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetRelatedAmbassadros`, { params });
  }

  getPlanOperators(planId: number): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetPlanOperators?planId=${planId}`);
  }

  getOperatorsBranches(planOperatorId: number): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetOperatorsBranches?planOperatorId=${planOperatorId}`);
  }

  getBasketsByPlan(planId: number): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetBasketsByPlan?planId=${planId}`);
  }

  getListMonitorTasks(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/ListMonitorTasks`, { params });
  }

  getTaskDetails(taskId: number): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetTaskDetails?taskId=${taskId}`);
  }

  getTaskLogs(taskId?: number) {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetTaskLogs?taskId=${taskId}`);
  }

  getMonitorTaskProductDetails(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetMonitorTaskProductDetails`, { params });
  }


  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/MonitorTask/AddTaskComment`, data);
  }
  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/MonitorTask/UpdateTaskComment`, data);
  }
  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/MonitorTask/DeleteTaskComment?commentId=${commentId}`);
  }

  getListTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/MonitorTask/ListTasksByAmbassador`, { params });
  }

  getMonitorTaskPriceScreen(params?: any) {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetMonitorTaskPriceScreen`, { params });
  }

  submitMonitorTaskPrice(body: any) {
    return this.http.post(`${environment.apiUrl}/MonitorTask/SubmitMonitorTaskPrice`, body);
  }

  getAvailableActions(taskId: number) {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetAvailableActions?taskId=${taskId}`);
  }

  changeTaskStatus(body: any) {
    return this.http.post(`${environment.apiUrl}/MonitorTask/ChangeTaskStatus`, body);
  }

  getetMonitorTaskProductAttachments(monitorTaskProductId: any) {
    return this.http.get(`${environment.apiUrl}/MonitorTask/GetMonitorTaskProductAttachments?monitorTaskProductId=${monitorTaskProductId}`);
  }

  runAi(taskId: number): any {
    return this.http.post(`${environment.apiUrl}/MonitorTask/RunAi?taskId=${taskId}`, null, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
